import React, { useContext, useEffect } from "react";
import { Box } from "@mui/material";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "AuthContextWrapper"
import { OUTCOMES } from "../../../constants";
import { NameFormSimple, Values } from "../shared/NameFormSimple";
import { ExecutorVerificationContext } from "ExecutorVerificationContextWrapper";
import { UserProfileAPI } from "apis/UserProfileAPI";
import { Loading } from "views/shared/Loading";
import { EXECUTOR_VERIFICATION_IN_PROGRESS_ID, EXECUTOR_VERIFICATION_NOT_STARTED_ID, EXECUTOR_VERIFICATION_STEP_BASIC_INFO_ID } from ".";

export const AboutYouNameScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { flow, user, setUser } = useAuthContext()
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);
  const { userProfile, loadingUserProfile, setUserProfile, getStepStatusId, setStepStatusId, verificationStepId, setVerificationStepId } = useContext(ExecutorVerificationContext);
  
  useEffect(() => {
    setVerificationStepId(EXECUTOR_VERIFICATION_STEP_BASIC_INFO_ID)
  }, [])

  const handleComplete = async (nameValues: Values): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    if(loadingUserProfile || !userProfile) {
      return false
    }

    try {
      userProfile.firstName = nameValues.firstName;
      userProfile.middleName = nameValues.middleName;
      userProfile.lastName = nameValues.lastName;

      setUserProfile(userProfile)
      await UserProfileAPI.update(userProfile.toJSON())
      
      if(user && setUser) {
        user.profile = userProfile
        user.first = userProfile.firstName
        user.middle = userProfile.middleName
        user.last = userProfile.lastName 
        setUser(user)
      }

      if(getStepStatusId(verificationStepId) === EXECUTOR_VERIFICATION_NOT_STARTED_ID) {
        await setStepStatusId(verificationStepId, EXECUTOR_VERIFICATION_IN_PROGRESS_ID)
      }

    } catch (error) {
      console.error("issue updating step, " + (error as any)?.message)
      // setIsSubmitting(false)
      return false
    }

    flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate);
    return true;
  };

  const handleBack = async (): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    flow?.navigateToNext(currentScreen, OUTCOMES.back, navigate);
    return true;
  };

  if (!currentScreen) {
    return <></>;
  }

  return (
    <FlowScreenWrapper
      title="First, let’s confirm your full legal name"
      subTitle={
        "Please use the legal name that appears on your Driver’s License, Passport, or Social Security Card."
      }
    >
      <div>
        <Box sx={{ mb: 2 }}>
          {loadingUserProfile && <Loading />}
          {!loadingUserProfile && <NameFormSimple
            onSubmit={handleComplete}
            onBack={handleBack}
            buttonColors="secondary"
            showSuffix={false}
            initData={{
              firstName: userProfile?.firstName || "",
              lastName: userProfile?.lastName|| "",
              middleName: userProfile?.middleName || "",
              suffix: userProfile?.nameSuffix || "",
            }}
          />}
        </Box>
      </div>
    </FlowScreenWrapper>
  );
};
